import React from "react";
import ReactDOM from "react-dom";
import { MuiThemeProvider, CssBaseline } from "@material-ui/core";
import { BrowserRouter as Router } from "react-router-dom";
import theme from "./theme";
import App from "./App";

function MainDetail(){
    return(
        <MuiThemeProvider theme={theme}>
            <CssBaseline />
            <Router>
            <App />
            </Router>
        </MuiThemeProvider>
    )
}

export default MainDetail